import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const OrderConfirmed = () => {
  const [orderData, setOrderData] = useState({
    orderNumber: "",
    orderDate: "",
    deliveryDate: "",
    items: [],
    subtotal: 0,
    tax: 0,
    shipping: 0,
    total: 0,
    user: {
      name: "",
      email: "",
      phone: "",
      address: "1st floor, 41 Rampuri Kalkaji, Huntsville, AL 110019",
    },
  });

  useEffect(() => {
    const cart = JSON.parse(sessionStorage.getItem("lastOrder")) || [];
    const subtotal = parseFloat(sessionStorage.getItem("orderSubtotal")) || 0;
    const tax = parseFloat(sessionStorage.getItem("orderTax")) || 0;
    const shipping = parseFloat(sessionStorage.getItem("orderShipping")) || 0;
    const total = parseFloat(sessionStorage.getItem("orderTotal")) || 0;

    const email = sessionStorage.getItem("userEmail") || "user@example.com";
    const firstName = sessionStorage.getItem("firstName") || "John";
    const lastName = sessionStorage.getItem("lastName") || "Kapoor";
    const phone = sessionStorage.getItem("phone") || "+1-833-551-6033";
    const address =
      sessionStorage.getItem("address") ||
      "1st floor, 41 Rampuri Kalkaji, Huntsville, AL 110019";

    const today = new Date();
    const orderDate = today.toLocaleDateString();
    const deliveryDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 7
    ).toLocaleDateString();

    setOrderData({
      orderNumber: Math.floor(Math.random() * 90000) + 10000,
      orderDate,
      deliveryDate,
      items: cart,
      subtotal,
      tax,
      shipping,
      total,
      user: { name: `${firstName} ${lastName}`, email, phone, address },
    });

    sessionStorage.removeItem("lastOrder");
  }, []);

  const {
    orderNumber,
    orderDate,
    deliveryDate,
    items,
    subtotal,
    tax,
    shipping,
    total,
    user,
  } = orderData;

  // 🔹 Download Invoice (PDF)
  const handleDownloadInvoice = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Invoice", 14, 20);
    doc.setFontSize(10);
    doc.text(`Order #${orderNumber}`, 14, 28);
    doc.text(`Date: ${orderDate}`, 14, 34);
    doc.text(`Delivery ETA: ${deliveryDate}`, 14, 40);

    doc.text("Customer Info:", 14, 50);
    doc.text(`${user.name}`, 14, 56);
    doc.text(`${user.email}`, 14, 62);
    doc.text(`${user.phone}`, 14, 68);
    doc.text(`${user.address}`, 14, 74);

    if (items.length > 0) {
      const itemRows = items.map((item) => [
        item.name,
        item.quantity || 1,
        `$${item.price}`,
        `$${(item.price * (item.quantity || 1)).toFixed(2)}`,
      ]);

      autoTable(doc, {
        startY: 84,
        head: [["Item", "Qty", "Price", "Total"]],
        body: itemRows,
      });
    }

    const finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 120;
    doc.text(`Subtotal: $${subtotal.toFixed(2)}`, 14, finalY);
    doc.text(`Tax: $${tax.toFixed(2)}`, 14, finalY + 6);
    doc.text(`Shipping: $${shipping.toFixed(2)}`, 14, finalY + 12);
    doc.text(`Total: $${total.toFixed(2)}`, 14, finalY + 18);

    doc.setFontSize(9);
    doc.text("Thank you for your purchase!", 14, finalY + 30);

    doc.save(`Invoice_${orderNumber}.pdf`);
  };

  return (
    <section className="order-confirm-section">
      <div className="order-confirm-wrapper">
        {/* 🔹 Top Section */}
        <div className="order-confirm-card order-confirm-top">
          <div className="order-confirm-left">
            <h2 className="order-confirm-number">Order #{orderNumber}</h2>

            <div className="order-confirm-grid">
              <div className="order-confirm-block">
                <h6 className="block-title">Order Details</h6>
                <div className="block-body">
                  <div>
                    Order Date: <span className="muted">{orderDate}</span>
                  </div>
                  <div>
                    Total: <strong>${total.toFixed(2)}</strong>
                  </div>
                  <div>
                    Items: <span className="muted">{items.length}</span>
                  </div>
                </div>
              </div>

              <div className="order-confirm-block">
                <h6 className="block-title">Customer Information</h6>
                <div className="block-body">
                  <div>{user.name}</div>
                  <div className="muted">{user.email}</div>
                  <div className="muted">{user.phone}</div>
                </div>
              </div>

              <div className="order-confirm-block">
                <h6 className="block-title">Shipping Address</h6>
                <div className="block-body">
                  <div>{user.address}</div>
                  <div className="muted">Est. Delivery: {deliveryDate}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="order-confirm-right">
            <div className="order-confirm-actions">
              <span className="badge order-confirm-status">Processing</span>
            </div>
          </div>
        </div>

        {/* 🔹 Items List */}
        <div className="order-confirm-card order-confirm-items">
          <h3 className="section-title">Order Items</h3>

          {items.length > 0 ? (
            items.map((item, index) => (
              <React.Fragment key={item.id || index}>
                <div className="item-row">
                  <div className="item-left">
                    <div className="item-title">{item.name}</div>
                    <div className="item-meta muted">
                      Quantity: {item.quantity || 1}
                    </div>
                  </div>
                  <div className="item-right">
                    <div className="item-price">${item.price}</div>
                    <div className="item-total muted">
                      ${(item.price * (item.quantity || 1)).toFixed(2)} total
                    </div>
                  </div>
                </div>
                {index < items.length - 1 && (
                  <div className="item-divider"></div>
                )}
              </React.Fragment>
            ))
          ) : (
            <p className="muted text-center mt-3">
              No recent order found or cart is empty.
            </p>
          )}
        </div>

        {/* 🔹 What's Next */}
        <div className="order-confirm-card order-confirm-next">
          <h3 className="section-title">What's Next?</h3>
          <ol className="next-steps">
            <li>
              <div className="step-num">1</div>
              <div className="step-content">
                <h6 className="step-title">Order Processing</h6>
                <p className="muted small">
                  We're preparing your items for shipment.
                </p>
              </div>
            </li>
            <li>
              <div className="step-num">2</div>
              <div className="step-content">
                <h6 className="step-title">Shipping Notification</h6>
                <p className="muted small">
                  You'll receive tracking info once your order ships.
                </p>
              </div>
            </li>
            <li>
              <div className="step-num">3</div>
              <div className="step-content">
                <h6 className="step-title">Delivery</h6>
                <p className="muted small">
                  Your order will arrive at your address soon.
                </p>
              </div>
            </li>
          </ol>
        </div>

        {/* 🔹 CTA Buttons */}
        <div className="order-confirm-cta-wrapper mb-40">
          <div className="mt-24 flex-align flex-wrap gap-16">
            <button
              onClick={handleDownloadInvoice}
              className="bg-main-600 hover-bg-neutral-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1 text-white fw-medium"
            >
              Download Invoice (PDF)
              <span className="w-36 h-36 bg-neutral-600 rounded-8 flex-center text-xl text-white">
                <i className="ph ph-download" />
              </span>
            </button>

            <Link
              to="/order-track"
              className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1"
            >
              <span className="text-white fw-medium">Track Your Order</span>
              <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white">
                <i className="ph ph-record" />
              </span>
            </Link>

            <Link
              to="tel:+1-206-466-6995"
              className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1"
            >
              <span className="text-white fw-medium">
                Call: +1-206-466-6995
              </span>
              <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white">
                <i className="ph ph-phone" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrderConfirmed;
